import { type OpenAPISpec, OpenAPISpecProcessingState } from '@gitbook/api-client';

/**
 * Check if the OpenAPI spec is in a processing state.
 */
export function checkIsOpenAPISpecProcessing(openAPISpec: OpenAPISpec) {
    return (
        openAPISpec.processingState === OpenAPISpecProcessingState.Pending ||
        openAPISpec.processingState === OpenAPISpecProcessingState.Progress
    );
}
